import { Component, Input } from '@angular/core';

const DEFAULT_ICON_SIZE = 16;

@Component({
  selector: 'app-arrow-up-icon',
  standalone: true,
  templateUrl: './arrow-up-icon.component.html',
  styles: [`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `]
})
export class ArrowUpIconComponent {
  @Input() size?: number = DEFAULT_ICON_SIZE;
  @Input() width?: number;
  @Input() height?: number;
}
